// extracted by mini-css-extract-plugin
export default {"mainOuterContainer":"MainContainer_mainOuterContainer__Ynw56","mainInnerContainer":"MainContainer_mainInnerContainer__1v7U2"};